export default "__VITE_ASSET__DU2UzQGN__"